<script>
import ModalLog from "@/components/ModalLog.vue";
import axios from "axios";
import _ from "lodash";
import {EventBus} from "@/eventBus";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "NewServer",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  props: {
    modalName: String
  },
  data() {
    return {
      newIpAddress: '',
      newIpDc: null,
      newIpMask: null,
      newIpGateway: null,
      createIpAction: false,
      DatacenterOptions: [],
      selectHeight: '120px',
      apiIpsList: '/api/manager/ip/list?sort=id&free=y',
      apiTypeList: '/api/manager/server-entities',
      apiUrl: "/api/manager/server/",
      formData: {
        Name: {
          value: ''
        },
        RealName: {
          value: ''
        },
        Entity: {
          value: '',
          options: []
        },
        IpId: {
          value: '',
          options: []
        }
      },
      textareaData: '',
      error: '',
      loader: null,
      newDcModalOpened: false,
    }
  },
  components: {ModalLog},
  methods: {
    loadEntity() {
      axios.get(this.apiTypeList, this.authRespConf())
          .catch((err) => {
            this.loader.hide();
            this.errorHandle(err);
          })
          .then(res => {
            this.loader.hide();
            this.formData.Entity.options = _.map(res.data.data, (item, key) => {
              return {
                label: item,
                value: parseInt(key)
              }
            })
          })
    },
    loadDatacenters() {
      axios.post('/api/manager/dc/flat?sort=Ip', [], this.authRespConf())
          .then(res => {
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                this.DatacenterOptions.push({
                  value: res.data.data[dataIndex]['Id'],
                  label: res.data.data[dataIndex]['Name'],
                });
              }
            }
          });
    },
    loadIps() {
      axios.post(this.apiIpsList, [], this.authRespConf())
          .catch((err) => {
            this.loader.hide();
            this.errorHandle(err);
          })
          .then(res => {
            this.loader.hide();
            this.formData.IpId.options = _.map(res.data.data, (item) => {
              return {
                label: item.Address,
                value: item.Id
              }
            })
          })
    },
    modalOpened() {
      this.formData = {
        Name: {
          value: ''
        },
        RealName: {
          value: ''
        },
        Entity: {
          value: '',
          options: []
        },
        IpId: {
          value: '',
          options: []
        }
      }
      this.loader = this.$loading.show()
      this.loadEntity()
      this.loadIps()
      this.selectHeight = this.$refs.modalBox.clientHeight + 'px;'
    },
    closeModal() {
      this.formData = {
        Name: {
          value: ''
        },
        RealName: {
          value: ''
        },
        Entity: {
          value: '',
          options: []
        },
        IpId: {
          value: '',
          options: []
        }
      }
      this.loaded = false
      this.$modal.hide('createServer')
    },
    updateSelectValue($event, key) {
      console.log($event)
      if ($event === null) {
        return
      }
      if (key === "Entity") {
        this.formData[key].value = parseInt($event.value)
      } else {
        this.formData[key].value = $event.value
      }
    },
    getValueForSelect(key) {
      const value = this.formData[key].value
      if (!value && key !== "Type") {
        return
      }
      if (key === "Type") {
        return this.formData[key].options.find(x => parseInt(x.value) === value)
      }
      return this.formData[key].options.find(x => x.value === value)
    },
    submitForm() {
      let loader = this.$loading.show();
      this.error = '';
      let data = {};
      for (let realFieldName in this.formData) {

        data[realFieldName] = this.formData[realFieldName].value
        if (this.formData[realFieldName].type === 'number' || this.formData[realFieldName].toType === 'number') {
          data[realFieldName] = parseInt(this.formData[realFieldName].value)
        }
        if (this.formData[realFieldName].type === 'select') {
          data[realFieldName] = this.formData[realFieldName].value
        }
        if (this.formData[realFieldName].type === 'json') {
          data[realFieldName] = JSON.stringify(this.jsonData[realFieldName]);
        }
        if (this.formData[realFieldName].type === 'textarea') {
          data[realFieldName] = this.trimText(this.formData[realFieldName].value)

        }

      }
      let itemId = parseInt(this.itemId);
      if (itemId > 0) {
        data['id'] = itemId;
      }
      axios.post(this.apiUrl, data, this.authRespConf())
          .then(res => {
            loader.hide();
            if (res !== null && res !== undefined) {
              if (res.data.message !== null && res.data.message !== undefined) {
                this.$bvToast.toast(res.data.message, {
                  title: 'Error',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: true
                })
                return
              }
            }
            this.$bvToast.toast('', {
              title: 'Server added successfully',
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: true
            })
            this.closeModal()
          })
          .catch((err) => {
            loader.hide();
            this.moveUp();
            this.errorHandle(err, true, true);
          });
    },
    checkAndCreateIp(ip) {
      // Регулярное выражение для проверки IP-адреса в формате "xxx.xxx.xxx.xxx"
      const ipRegex = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
      if (ipRegex.test(ip)) {
        return true;
      } else {
        this.$bvToast.toast('Invalid IP format', {
          title: 'Error',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        return false;
      }
    },
    createIp(newIp) {
      if (this.checkAndCreateIp(newIp.value)) {
        this.newIpAddress = newIp.value
        this.formData.IpId.value = null
      }
    },
    addNewIp(event) {
      if (event === null || this.newIpAddress.length <= 1) return;
      const payload = {
        Address: this.newIpAddress,
        DcId: this.newIpDc,
        Gateway: this.newIpGateway,
        Mask: this.newIpMask,
      }
      axios.post('api/manager/ip/', payload, this.authRespConf()).then(async (res) => {
        this.$bvToast.toast(res.data.Address, {
          title: 'IP added successfully',
          autoHideDelay: 5000,
          variant: 'success',
          appendToast: true
        })
        this.addOption({
          value: res.data.Id,
          label: res.data.Address
        });
        this.$modal.hide('selectDatacenterForNewIp')
        this.newDcModalOpened = false;
      }).catch((err) => {
        this.errorHandle(err, true, true, 'Add IP Error');
        this.formData.IpId.value = null
        this.closeSelectDatacenterForNewIp()
      })
    },
    closeSelectDatacenterForNewIp() {
      this.$modal.hide('selectDatacenterForNewIp')
      this.newDcModalOpened = false;
      this.newIpDc = null
      this.newIpMask = null
      this.newIpGateway = null
      this.newIpAddress = null
    },
    updateIpValue(newValue) {
      this.$set(this.formData.IpId, 'value', newValue);
    },
    addOption(option) {
      this.formData.IpId.options.push(option);
      this.updateIpValue(option.value);
    },
    modalsHide() {
      console.log("createServer modalsHide");
      if (this.newDcModalOpened === false) {
        this.closeModal();
      } else {
        this.closeSelectDatacenterForNewIp();
      }
    },
  },
  watch: {
    newIpAddress(val) {
      if (val) {
        this.$modal.show('selectDatacenterForNewIp')
        this.newDcModalOpened = true;
      }
    }
  },
  computed: {
    IpIdValue: {
      get: function () {
        return this.formData.IpId.value
      },
      set(newValue) {
        this.$set(this.formData.IpId, 'value', newValue);
      }
    }
  },
  created: function () {
    EventBus.$on("EscapeKeyDown", this.modalsHide);
  },
  beforeDestroy() {
    EventBus.$off("EscapeKeyDown", this.modalsHide);
  },
}
</script>

<template>
  <modal
      :draggable="true"
      :resizable="true"
      :clickToClose="false"
      name='createServer'
      :min-width="425"
      :width="850"
      :min-height="(500 / 2)"
      :height="500"
      :scrollable="true"
      @opened="modalOpened"
      @closed="closeModal"
      class="modalBox"
      :style="{'--selectHeight': selectHeight}"
  >
    <modal
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        name='selectDatacenterForNewIp'
        :min-width="425"
        :width="550"
        :min-height="(450 / 2)"
        :height="450"
        :scrollable="true"
        @opened="loadDatacenters"
        @closed="closeSelectDatacenterForNewIp"
        class="modalBox"
        :style="{'--selectHeight': selectHeight}"
    >
      <div class="window-header">
        Select Datacenter for IP: {{ newIpAddress }}
        <a href="javascript:void(0)" class="close-modal pull-right" @click="closeSelectDatacenterForNewIp">
          <i class="fa fa-times"></i>
        </a>
      </div>
      <div class="modal-body">
        <form ref="form" class="form-horizontal" @submit.prevent="addNewIp">
          <div class="row">
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Gateway *</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="newIpGateway">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Mask *</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="newIpMask">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Datacenter for new IP *</label>
              <v-select required :options="DatacenterOptions" :reduce="dc => dc.value" v-model="newIpDc"
                        placeholder="Datacenter"
                        inputId="dcName"/>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mt-2"><p class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeSelectDatacenterForNewIp" class="btn btn-danger text-white mr-2">
                Cancel
              </button>
              <button type="submit" class="btn btn-primary">Create</button>
            </div>
          </div>
        </form>
      </div>
    </modal>
    <div class="window-header">
      New Server
      <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal">
        <i class="fa fa-times"></i>
      </a>
    </div>
    <div class="modal-body" ref="modalBox">
      <div class="page-modal" style="background:white">
        <form ref="form" class="form-horizontal" @submit.prevent="submitForm">
          <div class="row">
            <div class="col-sm-12">
              <label class="col-form-label" for="name">Name <span class="text-danger">*</span></label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="formData.Name.value">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Type <span class="text-danger">*</span></label>
              <v-select :options="formData.Entity.options"
                        :reduce="entity => entity.value"
                        v-model="formData.Entity.value"
                        clearable
                        required
                        maxHeight="50px"
                        placeholder="N/A"
                        name="type"
                        inputId="valueType"/>
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="ip">Ip <span class="text-danger">*</span></label>
              <v-select :options="formData.IpId.options"
                        :reduce="ip => ip.value"
                        :create-option="ip => ({ label: ip, value:ip  })"
                        taggable
                        required
                        @option:created="createIp"
                        v-model="IpIdValue"
                        clearable
                        maxHeight="50px"
                        placeholder="N/A"
                        name="ip"
                        ref="ipIdSelect"
                        inputId="valueIp"/>
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="real_name">Comment</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  name="real_name"
                  v-model="formData.RealName.value">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mt-2"><p class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeModal" class="btn btn-danger text-white mr-2">Cancel
              </button>
              <button type="submit" class="btn btn-primary">Create</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ModalLog :data="textareaData" :modalName="'itemTextarea'" @close="closeModal"/>
  </modal>
</template>

<style scoped>

</style>